module.exports = __webpack_public_path__ + "media/images/shared/icon_area_black-9d28ccffcabffcf41e5eb65378bdf286.png";